import { createSlotRecipe } from './runtime.mjs';

const cardConfig = {"name":"card","className":"ds-card","slots":["root","header","caption","title","body","footer"],"defaultVariants":{"padding":"md","variant":"solid"},"variantMap":{"variant":["solid","glass","glassStrong"],"padding":["none","sm","md","lg"]}}

export const card = /* @__PURE__ */ createSlotRecipe(cardConfig)